export const COLORS = [
  'var(--text-green)',
  'var(--text-pink)',
  'var(--text-violet)',
  'var(--text-wave)',
];
